import { CustomForm } from "../customform/CustomForm";
import { observer } from "mobx-react";
import { useStoreContext } from "../..";
import { useEffect, useState } from "react";
import { getFieldInputs } from "../customform/fields/fieldsHelper";
import { FieldGroup } from "../../models/FieldGroups";
import React from "react";
import { z } from "zod";

const GenericForm = observer(
  <T extends z.ZodType<any, any, any>>({
    currentData,
    clientFormId,
    formId,
    zodDataSchema,
    onDeSelect,
    onSave,
    onUpdate,
    initialValues,
  }: {
    currentData: any | undefined;
    formId: number | undefined;
    clientFormId?: number | undefined;
    zodDataSchema?: T | undefined;
    onDeSelect?: () => void;
    onSave?: (data: any) => void;
    onUpdate?: (data: any) => void;
    initialValues?: any | undefined;
  }) => {
    const [fieldGroup, setFieldGroup] = useState<FieldGroup | null>(null);
    const [fieldInputs, setFieldInputs] = useState<React.ReactNode | null>(
      null
    );
    const { fieldStore } = useStoreContext();
    useEffect(() => {
      const fetchFields = async () => {
        if (!fieldStore.fieldGroups) {
          await fieldStore.getFieldGroups();
        }
        if (!fieldStore.fields) {
          await fieldStore.getFields();
        }
        const fields = fieldStore.fields;
        const fieldGroup = fieldStore.fieldGroups?.find((a) => a.id === formId);
        if (fieldGroup) {
          setFieldGroup(fieldGroup);
        }

        if (fields && fieldGroup) {
          const inputs = getFieldInputs(fields, fieldGroup);
          if (inputs) {
            setFieldInputs(inputs);
          }
        }
      };
      fetchFields();
    }, []);

    return (
      <>
        {fieldInputs && (
          <CustomForm
            zodDataSchema={zodDataSchema}
            initialValues={initialValues}
            currentData={
              currentData ||
              ({ formId: fieldGroup?.id ?? 0, values: [] } as any)
            }
            onSave={onSave}
            onUpdate={onUpdate}
            onDeSelect={onDeSelect}
            hideDeleteAndEditButtons
            hideReadOnlyChip
            hideSaveButton
          >
            {fieldInputs}
          </CustomForm>
        )}
      </>
    );
  }
);

export default React.memo(GenericForm);
